var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "skip-to-content-container col-12 px-0 text-center float-left"
    },
    [
      _c(
        "a",
        {
          staticClass: "skip-to-content-link mx-auto",
          attrs: { href: "javascript:void(0)", tabindex: "0" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.skip($event)
            }
          }
        },
        [_vm._v("\n      Skip to Main Content\n    ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f016935", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f016935","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/shared/SkipToContent.vue
// module id = null
// module chunks = 